import { ExclamationCircleFilled } from '@ant-design/icons'
import { Modal } from 'antd'

import Box from '~/core/Box'
import Text from '~/core/Text'
import Button from '~/core/Button'
import getColor from '~/lib/getColor'

type MfaWarningModal = {
    visible: boolean
    closeModal: () => void
}

const PLACEMENT = 'mfa-warning-modal'

export default function MfaWarningModal(props: MfaWarningModal) {
    const { visible, closeModal } = props

    return (
        <Modal
            bodyStyle={{ padding: '24px 12px 12px 24px' }}
            centered
            footer={null}
            visible={visible}
            closable={false}
            afterClose={closeModal}
            width="445px"
            maskClosable={false}
        >
            <Box>
                <ExclamationCircleFilled
                    style={{
                        color: getColor('warning'),
                        fontSize: '21px',
                        marginRight: '18px',
                    }}
                />
                <Box direction="col" flex="1">
                    <Text
                        fontSize="16px"
                        color="blackAlpha65"
                        style={{ marginBottom: '12px', width: '90%' }}
                    >
                        Two-factor authentication is required
                    </Text>
                    <Text
                        color="blackAlpha65"
                        style={{
                            marginBottom: '48px',
                        }}
                    >
                        To regain access to the Fictiv app, two-factor
                        authentication must be enabled on this account.
                    </Text>
                    <Box justifyContent="end">
                        <Button
                            type="primary"
                            onClick={closeModal}
                            name={`${PLACEMENT}-enable-2fa`}
                            placement={PLACEMENT}
                            data-test-target={`${PLACEMENT}-enable-2fa`}
                        >
                            Enable 2FA
                        </Button>
                    </Box>
                </Box>
            </Box>
        </Modal>
    )
}
